module.exports = __webpack_public_path__ + "img/img25.f8ecd006.svg";